<template>
  <div class="table-responsive d-table w-100 table-no-padding-first mb-5">
    <h3 class="mt-4">Survey information</h3>
    <table class="table first-td-500 table-alternative">
      <tbody>
        <tr>
          <td>{{ screentexts[72] ? screentexts[72].element_text : 'Survey name' }}</td>
          <td class="editable normal-input">
            <input v-if="editable" :value="survey.survey_name" :class="`form-control ${anon ? 'g-anon' : ''}`" @input="$emit('update:surveyName', $event.target.value)" />
            <span v-else :class="`${anon ? 'g-anon' : ''}`">{{ survey.survey_name }}</span>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[71] ? screentexts[72].element_text : 'Form type' }}</td>
          <td class="editable normal-input">
            <span>{{ surveytypeName }}</span>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[73] ? screentexts[73].element_text : 'Start date and time' }}</td>
          <td class="editable">
            <div>
              <div v-if="editable && surveyStatusId < 3" class="d-flex">
                <BaseDatePicker
                  id="start_date"
                  :model-value="surveyStartDate"
                  :min-datetime="new Date().toLocaleDateString('sv-SE')"
                  @update:model-value="$emit('update:surveyStartDate', $event); saveStartDateTime($event, surveyStartTime)"
                />
                <Datetime
                  id="survey_start_time"
                  :value="surveyStartTime"
                  type="time"
                  input-class="form-control"
                  :format="'HH:mm'"
                  :placeholder="screentexts[62] ? screentexts[62].element_text : 'Select sending time'"
                  @input="onStartTimeInput"
                />
              </div>
              <span v-else>
                {{ surveyStartDate || 'Not set' }}
                {{ surveyStartTime || '' }}
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[74] ? screentexts[74].element_text : 'End date and time' }}</td>
          <td class="editable">
            <BaseDatePicker
              v-if="editable && surveyStatusId < 4"
              id="end_date"
              :model-value="surveyEndDate"
              type="date"
              :min-datetime="new Date().toISOString()"
              :timezone="'Europe/Stockholm'"
              @update:model-value="saveEndDate($event)"
            />
            <span v-else>
              {{ surveyEndDate > '1970-01-02' ? formatDate(surveyEndDate) : 'Not set' }}
            </span>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[75] ? screentexts[75].element_text : 'Language' }}</td>
          <td class="editable select-column">
            <select v-if="editable" :value="survey.survey_language_id" class="form-select" @change="onLanguageChange($event.target.value)">
              <option v-for="option in languageOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
            </select>
            <span v-else>{{ languageName }}</span>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[76] ? screentexts[76].element_text : 'Norm data' }}</td>
          <td class="editable select-column">
            <select
              v-if="editable"
              :value="surveyNormvaluesId"
              class="form-select"
              @change="$emit('update:surveyNormvaluesId', $event.target.value); savefield('survey_normvalues_id', $event.target.value)"
            >
              <option v-for="option in normValuesOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
            </select>
            <span v-else>{{ normvaluesCountryName }}</span>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[77] ? screentexts[77].element_text : 'Reminder' }}</td>
          <td class="editable">
            <div v-if="editable && Number(surveyStatusId) <= 3 && canremind" class="form-check d-flex align-items-center">
              <input
                id="survey_reminder_check"
                type="checkbox"
                :checked="Number(surveyReminder) === 1"
                :true-value="1"
                :false-value="0"
                class="form-check-input position-static me-2"
                @change="$emit('update:surveyReminder', $event.target.checked ? 1 : 0); savefield('survey_reminder', $event.target.checked ? 1 : 0)"
              />
              <label class="form-check-label" for="survey_reminder_check">
                {{ screentexts[77] ? screentexts[77].element_text : 'Reminder' }}
              </label>
            </div>
            <span v-else>{{ Number(surveyReminder) === 1 ? 'Yes' : 'No' }}</span>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[104] ? screentexts[104].element_text : 'Reminder date' }}</td>
          <td class="editable">
            <div>
              <div v-if="editable && surveyStatusId <= 3 && canremind">
                <BaseDatePicker
                  id="survey_reminder_date"
                  :model-value="surveyReminderDate"
                  type="date"
                  :min-datetime="reminderDateMin ? new Date(reminderDateMin).toISOString() : undefined"
                  :timezone="'Europe/Stockholm'"
                  @update:model-value="$emit('update:surveyReminderDate', $event); savefield('survey_reminder_date', $event)"
                />
              </div>
              <span v-else>{{ Number(surveyReminder) === 1 ? formatDate(surveyReminderDate) : 'Not set' }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>{{ screentexts[107] ? screentexts[107].element_text : 'Reminder email' }}</td>
          <td class="editable normal-input">
            <input
              v-if="editable && surveyStatusId <= 3 && canremind"
              :value="surveyReminderEmail"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :placeholder="screentexts[108] ? screentexts[108].element_text : 'Enter email address'"
              @change="$emit('update:surveyReminderEmail', $event.target.value); savefield('survey_reminder_email', $event.target.value)"
            />
            <span v-else>{{ surveyReminderEmail }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <button :disabled="saving" class="btn btn-secondary mt-3" @click="toggleEditable">
      {{ editable ? 'Save' : 'Edit' }}
    </button>
  </div>
</template>

<script>
import BaseDatePicker from './base/BaseDatePicker.vue'
import Datetime from './custom/Datetime.vue'

export default {
  name: 'GroupSurveyInfoForm',
  components: { BaseDatePicker, Datetime },
  props: {
    survey: { type: Object, required: true },
    anon: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    screentexts: { type: Array, default: () => [] },
    surveyStatusId: { type: Number, default: 0 },
    surveytypeName: { type: String, default: '' },
    surveyStartDate: { type: String, default: null },
    surveyStartTime: { type: String, default: null },
    surveyEndDate: { type: String, default: null },
    surveyReminder: { type: [Number, String], default: 0 },
    surveyReminderDate: { type: String, default: null },
    surveyReminderEmail: { type: String, default: '' },
    reminderDateMin: { type: [Date, Object], default: null },
    canremind: { type: Boolean, default: false },
    languageOptions: { type: Array, default: () => [] },
    normValuesOptions: { type: Array, default: () => [] },
    surveyNormvaluesId: { type: [Number, String], default: 0 },
    normvaluesCountryName: { type: String, default: '' },
    languageName: { type: String, default: '' }
  },
  emits: [
    'update:surveyName',
    'update:surveyLanguageId',
    'update:surveyStartDate',
    'update:surveyStartTime',
    'update:surveyNormvaluesId',
    'update:surveyReminder',
    'update:surveyReminderDate',
    'update:surveyReminderEmail',
    'survey-updated',
    'survey-date-changed'
  ],
  data () {
    return {
      editable: false,
      saving: false,
      formchanged: false,
      showtimeadjust: false
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return ''
      if (date instanceof Date) return date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })
      return String(date).substring(0, 10)
    },
    format_date (date) {
      return this.formatDate(date)
    },
    format_time (date) {
      if (!date) return ''
      if (typeof date === 'string' && date.length === 5) return date
      const d = new Date(date)
      if (isNaN(d.getTime())) return String(date)
      return d.toLocaleTimeString('sv-SE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' })
    },
    cet_to_date (datePart, timePart) {
      if (!datePart || !timePart || String(timePart).length !== 5) return null
      const attempt = new Date(`${datePart}T${timePart}:00+01:00`)
      const check = attempt.toLocaleString('sv-SE', { timeZone: 'Europe/Berlin' }).split(' ')[1].substring(0, 5)
      return check === timePart ? attempt : new Date(`${datePart}T${timePart}:00+02:00`)
    },
    local_to_cet (localDate, localTime) {
      if (!localDate || !localTime) return { date: localDate || '', time: localTime || '' }
      const d = new Date(`${String(localDate).substring(0, 10)}T${localTime}:00`)
      return {
        date: d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' }),
        time: d.toLocaleTimeString('sv-SE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' })
      }
    },
    validateform (fieldname, value) {
      let result = true
      if (this.survey.survey_name === '') {
        result = false
      }
      if (fieldname === 'survey_normvalues_id') {
        if (Number(value) === 0) result = false
      } else if (Number(this.surveyNormvaluesId) === 0) {
        result = false
      }
      return result
    },
    checkreadyforlaunch () {
      const membercount = this.$store.state.currentsurvey.membercount
      let ready = true
      if (Number(membercount) === 0) ready = false
      if (!this.surveyEndDate || this.surveyEndDate === '' || this.surveyEndDate < this.surveyStartDate) ready = false
      if (!this.surveyStartDate || this.surveyStartDate === '') ready = false
      if (ready) {
        const data = { id: this.$store.state.currentsurvey.id, survey_status_id: 2 }
        this.formchanged = false
        this.$store.dispatch('groupsurvey_save', { survey: data }).then(() => {
          this.$emit('survey-updated')
        })
      }
    },
    savefield (fieldname, value) {
      if (this.loading) return
      let v = value
      if (fieldname === 'survey_reminder' && !v) v = 0
      if (fieldname.indexOf('_date') !== -1) v = this.format_date(v)
      if (fieldname.indexOf('_time') !== -1) v = (v && v !== '') ? this.format_time(v) : '00:00'
      if (this.validateform(fieldname, v)) {
        const data = { id: this.$store.state.currentsurvey.id, [fieldname]: v }
        this.formchanged = false
        this.$store.dispatch('groupsurvey_save', { survey: data })
          .then(() => {
            if (Number(this.surveyStatusId) === 1) this.checkreadyforlaunch()
            if (fieldname === 'survey_start_date') this.$emit('survey-date-changed')
          })
          .then(() => this.$emit('survey-updated'))
      }
    },
    saveform () {
      if (!this.saving) {
        this.saving = true
        this.formchanged = false
        const data = {
          id: this.$store.state.currentsurvey.id,
          survey_name: this.survey.survey_name,
          survey_normvalues_id: this.surveyNormvaluesId,
          survey_language_id: this.survey.survey_language_id,
          survey_start_date: this.format_date(this.surveyStartDate),
          survey_start_time: this.format_time(this.surveyStartTime),
          survey_end_date: this.format_date(this.surveyEndDate),
          survey_reminder_date: this.format_date(this.surveyReminderDate),
          survey_reminder_time: this.format_time(this.$store.state.currentsurvey.survey_reminder_time),
          survey_reminder: this.surveyReminder,
          survey_reminder_email: this.surveyReminderEmail
        }
        this.$store.dispatch('groupsurvey_save', { survey: data })
          .then(() => {
            this.$emit('survey-date-changed')
            this.$emit('survey-updated')
            this.saving = false
          })
      }
    },
    toggleEditable () {
      this.editable = !this.editable
      const rows = document.querySelectorAll('.table-alternative tr')
      rows.forEach(row => {
        if (this.editable) {
          row.classList.add('editable-row')
        } else {
          row.classList.remove('editable-row')
          this.saveform()
        }
      })
    },
    saveEndDate (value) {
      if (this.loading) return
      const dateStr = this.format_date(value)
      const data = { id: this.$store.state.currentsurvey.id, survey_end_date: dateStr }
      this.$store.dispatch('groupsurvey_save', { survey: data })
        .then(() => {
          this.$emit('survey-date-changed')
          this.$emit('survey-updated')
        })
    },
    saveStartDateTime (date, time) {
      if (this.loading) return
      const d = date || this.surveyStartDate
      const t = time || this.surveyStartTime
      const cet = this.local_to_cet(d, t)
      const data = {
        id: this.$store.state.currentsurvey.id,
        survey_start_date: cet.date,
        survey_start_time: cet.time
      }
      this.$store.dispatch('groupsurvey_save', { survey: data })
        .then(() => {
          this.$emit('survey-date-changed')
          this.$emit('survey-updated')
        })
    },
    onStartTimeInput (val) {
      this.$emit('update:surveyStartTime', val)
      this.checkstartdate()
      this.saveStartDateTime(this.surveyStartDate, val)
    },
    checkstartdate () {
      if (this.loading) return
      this.showtimeadjust = false
      if (!this.surveyStartDate || !this.surveyStartTime) return
      const surveydate = new Date(`${this.surveyStartDate}T${this.surveyStartTime}:00`)
      if (surveydate < new Date()) this.showtimeadjust = true
    },
    onLanguageChange (value) {
      this.$emit('update:surveyLanguageId', value)
      this.changelanguage(value)
    },
    changelanguage (survey_language_id) {
      this.$store.dispatch('groupsurvey_changelanguage', {
        survey_id: this.$store.state.currentsurvey.id,
        survey_language_id
      }).then(() => {
        this.savefield('survey_language_id', survey_language_id)
      })
    }
  }
}
</script>
